"use strict";import{tag as e}from"../custom-tag.js";export function mapIcon({height:a=16,width:t=16,hidden:l=!1,title:r="Map"}={}){return e`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${t}
      height=${a}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${l?"true":"false"}"
      role="img"
      aria-label="${r}"
    >
      <mask
        id="map_svg__mask0_6875_6129"
        width="18"
        height="20"
        x="3"
        y="2"
        maskUnits="userSpaceOnUse"
        style="mask-type:alpha"
      >
        <path
          fill="currentColor"
          d="M11.786 22a.52.52 0 0 1-.389-.167L5.843 16.28A8.37 8.37 0 0 1 17.696 4.46a8.376 8.376 0 0 1 0 11.82l-5.555 5.554a.52.52 0 0 1-.355.167m0-18.884A7.254 7.254 0 0 0 6.665 15.49l5.12 5.121 5.122-5.12a7.255 7.255 0 0 0-5.121-12.375"
        />
        <path
          fill="currentColor"
          d="M11.786 13.769a3.055 3.055 0 1 1 3.044-3.044 3.044 3.044 0 0 1-3.044 3.044m0-4.988a1.944 1.944 0 1 0 1.933 1.944 1.93 1.93 0 0 0-1.933-1.944"
        />
      </mask>
      <g mask="url(#map_svg__mask0_6875_6129)">
        <path fill="currentColor" d="M24 0H0v24h24z" />
      </g>
    </svg>
  `}
//# sourceMappingURL=map.js.map
